import { createI18n } from 'vue-i18n'
import messages from './locales'

const supportedLocales = ['en', 'he'] as const

export type SupportedLocale = (typeof supportedLocales)[number]
type MessageSchema = typeof messages.en

const isSupportedLocale = (value: string): value is SupportedLocale => {
  return supportedLocales.some((locale) => locale === value)
}

class I18nInstance {
  private i18n = createI18n<MessageSchema, string, false>({
    legacy: false,
    locale: 'he',
    fallbackLocale: 'en',
    messages,
  })

  constructor() {
    this.setLocale()
  }

  setLocale(): void {
    const storageLocale = localStorage.getItem('locale')
    const browserLocale = navigator.language.split('-')[0].toLowerCase()
    const matchedStorageLocale = supportedLocales.find(
      (locale) => locale === storageLocale
    )
    const matchedBrowserLocale = supportedLocales.find(
      (locale) => locale === browserLocale
    )
    const nextLocale: SupportedLocale =
      matchedStorageLocale ?? matchedBrowserLocale ?? 'en'

    this.i18n.global.locale.value = nextLocale
  }

  switchLocale(clickedValue: string): void {
    if (!isSupportedLocale(clickedValue)) {
      return
    }

    this.i18n.global.locale.value = clickedValue
    localStorage.setItem('locale', clickedValue)
  }

  isLocale(locale: string): boolean {
    return isSupportedLocale(locale) && this.i18n.global.locale.value === locale
  }

  get instance() {
    return this.i18n
  }
}

export const i18nInstance = new I18nInstance()
export default i18nInstance.instance
